const buildParams = (params) => {
    let result = []

    for (let i in params) {
        result.push(encodeURIComponent(i) + '=' + encodeURIComponent(params[i]))
    }

    return result.join('&')
}

const remove = (script) => {
    if (script) {
        script.onload = script.onreadystatechange = script.onerror = null

        if (script.parentNode) {
            script.parentNode.removeChild(script)
        }

        script = null
    }
}

const checkSrc = (src) => {
    if (src.indexOf('?') >= 0) {
        return '&'
    }

    return '?'
}

const onload = (script) => {
    if (!script.readyState || /loaded|complete/.test(script.readyState)) {
        remove(script)
    }
}

const onerror = (script, reject) => {
    remove(script)

    reject(new Error('Network Error'))
}

const jsonpAdapter = (config) => {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script')
        let src = config.url

        if (config.params) {
            const params = buildParams(config.params)

            if (params) {
                src += checkSrc(src) + params
            }
        }

        script.async = true

        const jsonp = config.params.callbackName
        const old = window[jsonp]
        let isAbort = false

        window[jsonp] = function (responseData) {
            window[jsonp] = old

            if (isAbort) {
                return
            }

            let response = {
                data: responseData,
                status: 200
            }

            resolve(response)
        }

        const additionalParams = {
            _: new Date().getTime()
        }

        src += checkSrc(src) + buildParams(additionalParams)

        script.onload = script.onreadystatechange = () => onload(script)

        script.onerror = () => onerror(script, reject)

        if (config.cancelToken) {
            config.cancelToken.promise.then(function (cancel) {
                if (!script) {
                    return
                }

                isAbort = true

                reject(cancel)
            })
        }

        script.src = src

        document.head.appendChild(script)
    })
}

export default jsonpAdapter
